import React from "react";
import SellwisorImage from "assets/images/sellwisor-logo.png";

const SellwisorLogo = ({ width = 11, height = 11, ...other }) => (
  <img src={SellwisorImage} width={width} height={height} alt="Sellwisor Logo" {...other} />
);

export default SellwisorLogo;
